import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { LeadsPage } from "@/pages/leads";
import { leadStatusSchema } from "@/schemas/models/lead";

const leadsSearchSchema = z.object({
  page: z.coerce.number().min(1).catch(1).optional(),
  search: z.string().optional(),
  leadStatus: z.enum([...leadStatusSchema.options, "all"]).optional(),
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  leadId: z.string().optional(),
  eventId: z.string().optional(),
});

export const Route = createFileRoute("/_app/speed-to-lead/leads")({
  validateSearch: leadsSearchSchema,
  staticData: { title: "Leads", breadcrumb: "Leads" },
  component: LeadsPage,
});
